import React, { FC, useContext, useEffect } from "react";
import { useLoaderData } from "react-router-dom";
import { ContextHeader } from "../../components/header/secondary";
import { DashboardHeaderContext } from "../../../hook/header";
import { UserVisitControl } from "../../../domain/control/Visit";
import { VisitControlView } from "./components/view";

export const VisitControlPage: FC<any> = () => {
  const data = useLoaderData() as UserVisitControl;
  /* eslint-disable */
  const dashboardHeaderContext = useContext(DashboardHeaderContext);
  useEffect(() => {
    dashboardHeaderContext.setTheme({
      className: "bg-gray-100",
      title: "Visita",
      dark: false,
      subtitle: data.owner?.displayName,
      homeAsUpEnabled: true,
    });
  }, []);
  /* eslint-enable */
  return (
    <div className={"w-full h-full flex flex-col overflow-hidden px-3"}>
      <ContextHeader
        breadcrumbItems={[
          {
            label: "Control de Visitas",
            path: "/dashboard/visit-control-group",
          },
          {
            label: "...",
            active: true,
          },
        ]}
        title={"Registro de Control de Visita"}
      />
      <div className={"p-3 flex-1 w-full overflow-y-auto"}>
        <VisitControlView visitControl={data} />
      </div>
    </div>
  );
};
